import React from 'react';
import styled from 'styled-components';
import { StoryGenerator } from '../components/StoryGenerator';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const CreateStoryContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
`;

export const CreateStoryPage: React.FC = () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  
  // Redirect to login if not logged in
  React.useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { state: { from: '/create' } });
    }
  }, [isLoggedIn, navigate]);
  
  if (!isLoggedIn) {
    return null;
  }
  
  return (
    <CreateStoryContainer>
      <StoryGenerator />
    </CreateStoryContainer>
  );
};